import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useState } from 'react';
import { Dropdown } from "primereact/dropdown";
import { InputNumber } from "primereact/inputnumber";
import { InputSwitch } from "primereact/inputswitch";
import { MAX_LARGO_DESCRIPCION } from '../../../utilities/textValidations.js';

const FormCrearSubproducto = ({
    displayDialog,
    setDisplayDialog,
    subproducto,
    setSubproducto,
    handleCreateSubproducto,
    unidad,
    setUnidad,
    tarifa,
    setTarifa,
    incluido,
    setIncluido,
    baseUrl,
    nombreEmpresa
}) => {
    const [unidades] = useState([{ label: "Metro cuadrado (m²)", value: "m**2" }]);
    const limpiarFormulario = () => {
        setSubproducto({descripcion: ""});
        setUnidad("");
        setTarifa("");
        setIncluido(false);
        setDisplayDialog(false);
    };
    // Función para manejar la creación del subproducto
    const handleCrearSubproducto = async () => {
        try {
            // Llamar a la función original de crear subproducto
            await handleCreateSubproducto();
        } catch (error) {
            console.error("Error al crear producto:", error);
        }
    };

    const footerCrearProd = () => {
        return (
            <div className="p-d-flex p-jc-end p-mt-3">
                <Button
                    label="Cancelar"
                    icon="pi pi-times"
                    onClick={limpiarFormulario}
                    className="p-button p-mr-2 p-button-outlined p-button-rounded"
                />
                <Button
                    label="Guardar"
                    icon="pi pi-save"
                    onClick={handleCrearSubproducto}
                    className="p-button-success p-button-rounded p-button"
                    raised
                    autoFocus
                    disabled={!(subproducto.descripcion && unidad && tarifa)}
                />
            </div>
        );
    };

    return (
        <div className="form-container">
            <Dialog
                visible={displayDialog}
                className="p-fluid product-dialog"
                onHide={limpiarFormulario}
                footer={footerCrearProd()}
                header={`Crear Subproducto de ${nombreEmpresa}`}
            >
                <div className="card">
                    <h6 className="mb-3">
                        Información
                    </h6>

                    <span className="p-float-label mt-2 mb-3">
                        <InputText
                            id="descripcion"
                            value={subproducto.descripcion}
                            onChange={(e) =>
                                setSubproducto({
                                    ...subproducto,
                                    descripcion: e.target.value.toUpperCase(),
                                })
                            }
                            className="p-inputtext-lg"
                            placeholder="Ingrese la descripción del subproducto"
                            required
                            maxLength={MAX_LARGO_DESCRIPCION}
                        />
                        <label htmlFor="descripcion">
                            <i className="pi pi-file-edit mr-2"></i>Descripción *
                        </label>
                    </span>

                    <span className="p-float-label mt-2 mb-3">
                        <Dropdown
                        id="unidad"
                        value={unidad}
                        options={unidades}
                        onChange={(e) => setUnidad(e.value)}
                        placeholder="Seleccione una unidad"
                        optionLabel="label"
                        className="p-inputtext-lg"
                        />
                        <label htmlFor="unidad"><i className="pi pi-cog"></i> Unidad*</label>
                    </span>
                    <span className="p-float-label mt-2 mb-3">
                        <InputNumber
                        id="tarifa"
                        value={tarifa}
                        onValueChange={(e) => setTarifa(e.value)} // Handle value change
                        mode="decimal" // Handle decimal numbers
                        minFractionDigits={0} // Set minimum number of decimal digits
                        maxFractionDigits={2} // Set maximum number of decimal digits
                        placeholder="Ingrese la tarifa en UF"
                        className="p-inputtext-lg"
                        locale="es-ES" // Set locale to use comma for decimal
                        inputMode="decimal" // HTML5 input mode for numeric decima
                        min={0.01}
                        max={1000}
                        />
                        <label htmlFor="tarifa"><i className="pi pi-money-bill"></i> Tarifa UF*</label>
                    </span>

                    <div className="flex align-items-center gap-2 mt-3 mb-3">
                        <InputSwitch
                            inputId="incluido"
                            checked={incluido === true}
                            onChange={(e) => setIncluido(e.value)}
                        />
                        <label htmlFor="incluido" className="mb-0">
                            <i className="pi pi-check-square mr-1"></i>Incluido por defecto en cotizaciones
                        </label>
                    </div>
                </div>
            </Dialog>
        </div>
    );
};

export default FormCrearSubproducto;
